import React from 'react';
import './StratXMethod.css';

const steps = [
  {
    number: '01',
    title: 'Deep Discovery',
    description: 'We dive deep into your business — understanding challenges, opportunities, market position, and goals through comprehensive analysis and stakeholder interviews.',
  },
  {
    number: '02',
    title: 'Strategic Blueprint',
    description: 'We create a customized strategic blueprint with clear roadmaps, actionable plans, and measurable objectives tailored to your unique situation.',
  },
  {
    number: '03',
    title: 'Execution & Guidance',
    description: "We don't just hand you a plan — we work alongside you to implement it, providing ongoing guidance, support, and course corrections as needed.",
  },
  {
    number: '04',
    title: 'Ongoing Optimization',
    description: 'We continuously monitor progress, measure results, and optimize strategies to keep you on track toward your growth objectives.',
  },
];

const StratXMethod = () => (
  <section id="method" className="sec">
    <div className="w">
      <div className="rv">
        <div className="eye">Our Process</div>
        <h2 className="sh">The <span>StratX</span> Method</h2>
        <p className="sl">A proven 4-step process that transforms strategic intent into measurable, sustainable growth.</p>
      </div>
      <div className="ms">
        {steps.map((step, index) => (
          <div className={`mst rv d${index + 1}`} key={step.number}>
            <div className="msn">
              <div className="msni">{step.number}</div>
            </div>
            <div className="msti">{step.title}</div>
            <div className="msd">{step.description}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StratXMethod;
